export default function FinalCtaSection() {
  return (
    <section className="relative overflow-hidden bg-[#0a1628] py-16 sm:py-20 lg:py-24">
      {/* Background accent */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-20 -left-20 w-96 h-96 bg-red-600/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Urgency badge */}
        <div className="inline-block bg-red-600 text-white px-5 py-2 rounded-full text-sm font-black uppercase tracking-wide mb-6 animate-pulse">
          ⚡ Act Now — Same-Day Service Available
        </div>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
          Stop the Damage<br />
          <span className="text-red-400">Before It Gets Worse</span>
        </h2>

        {/* Subtext */}
        <p className="text-lg sm:text-xl text-blue-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          Every hour a leak goes undetected, it costs you more. Call now for immediate service.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:7252675482"
            className="w-full sm:w-auto bg-red-600 text-white px-10 py-5 rounded-lg font-black text-xl hover:bg-red-500 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-3"
          >
            <i className="ri-phone-fill text-2xl"></i>
            Call Now
          </a>
          <a
            href="#contact"
            className="w-full sm:w-auto bg-transparent border-2 border-white/40 text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-white/10 hover:border-white transition-all whitespace-nowrap cursor-pointer text-center"
          >
            Get Free Estimate
          </a>
        </div>

        {/* Trust micro-copy */}
        <p className="mt-6 text-sm text-gray-400 italic">
          No obligation &nbsp;•&nbsp; Licensed &amp; Insured &nbsp;•&nbsp; Speak directly to a specialist
        </p>
      </div>
    </section>
  );
}
